module.exports = __webpack_public_path__ + "static/img/6336_phase_function_Paper_Points.76015ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6336_phase_function_Paper_Points.png
// module id = OHWM
// module chunks = 0